<template>
    <div class="cv-print-container" style="background: white; font-family: 'Roboto', sans-serif;">
        <!-- Header Section -->
        <v-row>
            <v-col cols="3" class="text-center pt-0">
                <v-avatar size="160" class="elevation-1" style="border: 4px solid #f0f0f0;">
                    <v-img :src="avatar || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'"></v-img>
                </v-avatar>
            </v-col>
            <v-col cols="9" class="pt-2 pl-4">
                <h1 style="color: #2e7d32; text-transform: uppercase; font-size: 28px; margin-bottom: 4px;">{{ form.name }}</h1>
                <h3 style="color: #555; font-size: 18px; font-weight: 500; margin-bottom: 12px;">{{ form.positionName }} - {{ form.positionStateName }}</h3>
                
                <div style="display: flex; flex-wrap: wrap; gap: 16px; margin-top: 16px;">
                    <div style="flex: 1; min-width: 45%;">
                        <div style="color: #666; font-size: 12px; text-transform: uppercase;">Mã nhân viên</div>
                        <div style="font-size: 15px; font-weight: bold;">{{ form.code || 'N/A' }}</div>
                    </div>
                    <div style="flex: 1; min-width: 45%;">
                        <div style="color: #666; font-size: 12px; text-transform: uppercase;">Trạng thái</div>
                        <div style="font-size: 15px; font-weight: bold; color: #d84315;">{{ statusText || 'N/A' }}</div>
                    </div>
                    <div style="flex: 1; min-width: 45%;">
                        <div style="color: #666; font-size: 12px; text-transform: uppercase;">Phòng ban</div>
                        <div style="font-size: 15px; font-weight: bold;">{{ form.departmentName || 'N/A' }}</div>
                    </div>
                    <div style="flex: 1; min-width: 45%;">
                        <div style="color: #666; font-size: 12px; text-transform: uppercase;">Đội / Nhóm</div>
                        <div style="font-size: 15px; font-weight: bold;">{{ form.teamName || 'N/A' }}</div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-divider style="margin: 24px 0; border-color: #2e7d32; border-width: 2px;"></v-divider>

        <!-- Body Section -->
        <v-row>
            <!-- Left Column: Personal Info -->
            <v-col cols="5" style="border-right: 1px solid #eee; padding-right: 24px;">
                <h2 style="color: #2e7d32; font-size: 18px; text-transform: uppercase; margin-bottom: 16px; border-bottom: 2px solid #e0e0e0; padding-bottom: 4px;">Thông tin cá nhân</h2>
                
                <div class="info-block">
                    <div class="info-label">Ngày sinh</div>
                    <div class="info-value">{{ formatDate(form.birthDay) }}</div>
                </div>
                <div class="info-block">
                    <div class="info-label">Giới tính</div>
                    <div class="info-value">{{ form.gender === true ? 'Nam' : (form.gender === false ? 'Nữ' : 'N/A') }}</div>
                </div>
                <div class="info-block">
                    <div class="info-label">Số điện thoại</div>
                    <div class="info-value">{{ form.phoneNumber || 'N/A' }}</div>
                </div>
                <div class="info-block">
                    <div class="info-label">Số điện thoại khẩn cấp</div>
                    <div class="info-value">{{ form.emergencyNumber || 'N/A' }}</div>
                </div>
                <div class="info-block">
                    <div class="info-label">Email</div>
                    <div class="info-value">{{ form.mail || 'N/A' }}</div>
                </div>
                <div class="info-block">
                    <div class="info-label">Căn cước công dân</div>
                    <div class="info-value">{{ form.idNumber || 'N/A' }} <br><small style="color:gray">Cấp ngày:  {{ formatDate(form.idDate) }}</small></div>
                </div>
                <div class="info-block">
                    <div class="info-label">Nơi cấp</div>
                    <div class="info-value">{{ form.idPlace || 'N/A' }}</div>
                </div>
            </v-col>

            <!-- Right Column: Work & other details -->
            <v-col cols="7" style="padding-left: 24px;">
                <h2 style="color: #2e7d32; font-size: 18px; text-transform: uppercase; margin-bottom: 16px; border-bottom: 2px solid #e0e0e0; padding-bottom: 4px;">Thông tin công tác</h2>
                
                <v-row>
                    <v-col cols="6" class="py-1">
                        <div class="info-block">
                            <div class="info-label">Khối</div>
                            <div class="info-value">{{ form.departmentTypeName || 'N/A' }}</div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                        <div class="info-block">
                            <div class="info-label">Ngày nhận việc</div>
                            <div class="info-value">{{ formatDate(form.hireDate) }}</div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                        <div class="info-block">
                            <div class="info-label">Ca làm việc</div>
                            <div class="info-value">{{ form.shiftName || 'N/A' }}</div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                        <div class="info-block">
                            <div class="info-label">Loại nhân sự</div>
                            <div class="info-value">{{ form.employeeType || 'N/A' }}</div>
                        </div>
                    </v-col>
                </v-row>

                <h2 style="color: #2e7d32; font-size: 18px; text-transform: uppercase; margin-top: 24px; margin-bottom: 16px; border-bottom: 2px solid #e0e0e0; padding-bottom: 4px;">Địa chỉ</h2>
                <div class="info-block">
                    <div class="info-label">Địa chỉ thường trú</div>
                    <div class="info-value">{{ form.originAddress || 'N/A' }}</div>
                </div>
                <div class="info-block">
                    <div class="info-label">Địa chỉ tạm trú</div>
                    <div class="info-value">{{ form.domicileAddress || 'N/A' }}</div>
                </div>

                <h2 v-if="form.educationLevelCode" style="color: #2e7d32; font-size: 18px; text-transform: uppercase; margin-top: 24px; margin-bottom: 16px; border-bottom: 2px solid #e0e0e0; padding-bottom: 4px;">Học vấn</h2>
                <div class="info-block" v-if="form.educationLevelCode">
                    <div class="info-label">Trình độ</div>
                    <div class="info-value">{{ formatEducationLevel(form.educationLevelCode) }}</div>
                </div>
                <div class="info-block" v-if="form.universityCode">
                    <div class="info-label">Nơi đào tạo</div>
                    <div class="info-value">{{ formatUniversity(form.universityCode) }}</div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: "EmployeePrintCV",
    props: {
        form: {
            type: Object,
            default: () => ({})
        },
        avatar: {
            type: String,
            default: ""
        },
        statusText: {
            type: String,
            default: ""
        },
        educationLevels: {
            type: Array,
            default: () => []
        },
        universities: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        formatDate(value, format = "DD/MM/YYYY") {
            if (!value) return 'N/A';
            return moment(value).format(format);
        },
        formatEducationLevel(code) {
            const level = this.educationLevels.find(x => x.code === code);
            return level ? level.name : code;
        },
        formatUniversity(code) {
            const uni = this.universities.find(x => x.code === code);
            return uni ? uni.name : code;
        }
    }
}
</script>

<style scoped>
.cv-print-container {
    color: #333;
}
.info-block {
    margin-bottom: 14px;
}
.info-label {
    color: #777;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 2px;
}
.info-value {
    color: #111;
    font-size: 15px;
    font-weight: 500;
}
</style>
